var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{on:{"click":function($event){return _vm.openHome()}}},[_vm._v("Julie Gobin")]),_c('div',{staticClass:"filet"})])}
var staticRenderFns = []

export { render, staticRenderFns }